import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { finalize, catchError, throwError } from "rxjs";
import { HttpService } from "src/app/services/http.service";
import {UtilService} from "../../services/util.service";
import {ChangeSecurityQuestionsResponse, List, SecurityQuestion} from "../../models/security";
import {ActivatedRoute} from "@angular/router";
import {SidebarService} from "../../services/sidebar.service";


@Component({
    selector: 'app-security-questions',
    templateUrl: './change-security-questions.component.html',
    styleUrls: ['./change-security-questions.component.scss'],
    standalone: false
})
export class ChangeSecurityQuestionsComponent implements OnInit {
  @ViewChild('fsQstns', { read: NgForm }) fsQstns!: NgForm;
  submitting = false;
  securityQuestions: SecurityQuestion[] = [];
  questionMap: Map<number, number> = new Map();
  newUser: boolean = false;

  constructor(private httpService: HttpService, private util: UtilService, private activatedRoute: ActivatedRoute, public sidebarService:SidebarService) { }

  ngOnInit(): void {
    const type = this.activatedRoute.snapshot.params['type'];
    if(type == 'new'){
      this.newUser = true;
      this.sidebarService.toggle(false);
      this.sidebarService.enabled = false;
    }
    this.getSecurityQuestions();
  }

  getSecurityQuestions() {
    this.httpService.Get<List>('/user/get-security-questions').subscribe((response) => {
      this.securityQuestions = response.list;
    });
  }

  onQuestionChange(questionId:number, questionNumber: number) {
    this.resetQuestion(questionId);
    this.questionMap?.set(questionId, questionNumber);
  }

  resetQuestion(questionId: number) {
    switch (this.questionMap?.get(questionId)) {
      case 1:
        this.fsQstns.controls['seqQue1Id'].reset();
        break;
      case 2:
        this.fsQstns.controls['seqQue2Id'].reset();
        break;
      case 3:
        this.fsQstns.controls['seqQue3Id'].reset();
        break;
    }
    ;
  }

  onSubmit(value: any) {
    this.submitting = true;
    const params = this.httpService.createHttpParams(value);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post<ChangeSecurityQuestionsResponse>('/change-sec-ques', params, options).pipe(
      finalize(() => { this.submitting = false }),
      catchError(err => {
        return throwError(err);
      })
    ).subscribe((response => {
      if (response.inputErrors) {
        let message = ' ';
        response.inputErrors.forEach(inputErrors =>  message += inputErrors.fieldName + ", with value: " + inputErrors.invalidValue + ", " + inputErrors.message + '<br/>');
        this.util.displayDialogMessage('Error', message);
      } else {
        if(this.newUser) {
          this.sidebarService.enabled = true;
          this.sidebarService.toggle(true);
        }
        this.fsQstns.reset();
        this.util.displayDialogMessage('Success', 'You have successfully updated your security questions.');

      }
    }));
  }

  help(){
    this.util.displayDialogMessage("Help",
      "EPDS is trying to make it easier for users to retrieve their forgotten passwords. The security questions and answers are a way to make your information more personal (memorable) and more difficult for others to guess. If you forget your password in the future, you will be able to use these questions and answers to reset your password.Tip: Please keep in mind that the answers you provide are not case sensitive, but they are space sensitive. For example, 'my high school' is not the same as 'myhighschool' because of the spaces used.");
  }

  onCancel() {
    this.fsQstns.reset();
  }
}
